import { useState } from "react";
import { Container, Paper, Box, Avatar, Typography, Grid } from "@mui/material";
import { AccountCircleRounded } from '@mui/icons-material';
import { useForm } from "react-hook-form";
import { Form, Input, Submit } from "../Form";
import { useDispatch } from "react-redux";
import { login } from "../../features/auth/authSlice";
import { useNavigate } from "react-router-dom";

const Login = () => {   
    const [showPassword, setShowPassword] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const methods = useForm();
    const onSubmit = values => dispatch(login({ values, setError: methods.setError, navigate }))
    const handleShowPassword = () => setShowPassword(!showPassword)
    return(
        <Container maxWidth={'xs'} component={Paper} sx={{ p: '2em' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                <Avatar sx={{ bgcolor: 'success.main' }}> <AccountCircleRounded /> </Avatar>
                <Typography variant="h5" align="center">Iniciar sesi&oacute;n</Typography>
            </Box>  
            <Form methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    <Input name={'user'} min={7} max={9}  regEx={/\w/ig} label='Usuario'/>
                    <Input name={'password'} type={ showPassword ? 'text' : 'password' } handleShowPassword={handleShowPassword} min={8} max={20}  regEx={/\w/ig} label='Contraseña'/>
                    <Submit title="Entrar" />
                </Grid>
            </Form>
        </Container>
    )
}

export default Login;